export const organizationHeaders = (organizationId?: string): { [key: string]: unknown } | undefined =>
	organizationId ? { headers: { "x-organization-id": organizationId } } : undefined;
